/* @generated */

// src/assets/ui-icon/line/checkmark.tsx
import * as React from "react";
var CheckmarkLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M5.5 11.5 10 16l8.25-8.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  CheckmarkLine
};
